/**
 * The single source of truth for which languages Echoes ships.
 *
 * Adding a language is a three-step change:
 *   1. add an entry here,
 *   2. drop the matching `src/i18n/locales/<code>/*.json` files in place and
 *      register them in `./resources.ts`, and
 *   3. add the code to `languageValidator` in convex/lib/validators.ts and
 *      the email dictionary in convex/lib/emailTemplates.ts.
 */
export const LANGUAGES = [
  { code: "en", endonym: "English" },
  { code: "fr", endonym: "Français" },
] as const;

export type LanguageCode = (typeof LANGUAGES)[number]["code"];

export const SUPPORTED_LANGUAGE_CODES: LanguageCode[] = LANGUAGES.map(
  (language) => language.code,
);

export const DEFAULT_LANGUAGE: LanguageCode = "en";

export const LANGUAGE_STORAGE_KEY = "echoes_lang";

/** Narrow an arbitrary string to a supported language code, else `undefined`. */
export function asLanguageCode(value: unknown): LanguageCode | undefined {
  if (typeof value !== "string") return undefined;
  const code = value.toLowerCase().slice(0, 2);
  return (SUPPORTED_LANGUAGE_CODES as string[]).includes(code)
    ? (code as LanguageCode)
    : undefined;
}
